
import { Component, Vue, Ref, Prop } from 'vue-property-decorator';
import { Loader, google } from 'google-maps';
import { GoogleMapConfig } from '@/flightpath-components/types/GoogleMapConfig';
import { getModule } from 'vuex-module-decorators';
import MachineStore from '@/store/modules/machine';
import MenuStore from '@/store/modules/menu';
import MissionStore from '@/store/modules/missions';
import GlobalStore from '@/store/modules/global';

@Component
export default class GoogleMapLoader extends Vue {
  @Ref() readonly googleMap!: HTMLDivElement;
  @Prop() readonly options!: GoogleMapConfig;
  @Prop({ default: '' }) readonly apiKey!: string;

  public machineStore = getModule(MachineStore, this.$store);
  public menuStore = getModule(MenuStore, this.$store);
  public missionStore = getModule(MissionStore, this.$store);
  public globalStore = getModule(GlobalStore, this.$store);

  googleApi = null as google | null;
  map = null as google.maps.Map<HTMLDivElement> | null;
  loader: Loader | null = new Loader(this.apiKey);
  mapClickListenerHandle: google.maps.MapsEventListener | null = null;

  initializeMap() {
    if (this.googleApi != null) {
      this.map = new this.googleApi.maps.Map(this.googleMap, this.options.mapOptions);
      this.addLocationControl();
      this.AddSelectedListner();
    }
  }

  private AddSelectedListner() {
    if (this.mapClickListenerHandle != null) {
      this.mapClickListenerHandle.remove();
    }
    if (this.map != null) {
      this.mapClickListenerHandle = this.map.addListener('click', () => {
        const route = this.$route.name;
        if (!this.machineStore.isRecording && route == 'Home') {
          this.machineStore.setSelectedMachine(null);
          this.machineStore.setSelectedMachineMarker(null);
          this.machineStore.setSelectedMachineIndex(null);
          this.menuStore.resetMachineMenuState();
          this.missionStore.selectMission(null);
          this.missionStore.setSelectedMissionIndex(null);
        }
      });
    }
  }

  addLocationControl() {
    if (this.googleApi != null && this.map != null && this.options.locationControl) {
      // Create a div to hold the control.
      const controlDiv = document.createElement('div');

      const firstChild = document.createElement('button');
      firstChild.style.backgroundColor = '#fff';
      firstChild.style.width = '28px';
      firstChild.style.height = '28px';
      firstChild.style.borderRadius = '2px';
      firstChild.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)';
      firstChild.style.cursor = 'pointer';
      firstChild.style.marginRight = '10px';
      firstChild.style.marginTop = '10px';
      firstChild.title = 'Your Location';
      controlDiv.appendChild(firstChild);

      const secondChild = document.createElement('div');
      secondChild.style.margin = '5px';
      secondChild.style.width = '18px';
      secondChild.style.height = '18px';
      secondChild.style.backgroundImage = 'url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-2x.png)';
      secondChild.style.backgroundSize = '180px 18px';
      secondChild.style.backgroundPosition = '0px 0px';
      secondChild.style.backgroundRepeat = 'no-repeat';
      firstChild.appendChild(secondChild);

      // Add the control to the map
      this.map.controls[this.googleApi.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv);
      secondChild.addEventListener('click', () => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((pos) => {
            if (this.googleApi != null) {
              const me = { lat: pos.coords.latitude, lng: pos.coords.longitude };
              if (this.map != null) this.map.panTo(me);
              this.globalStore.updateCenterLocation(me);
            }
          });
        }
      });
    }
  }

  destroyed() {
    if (this.mapClickListenerHandle != null) {
      this.mapClickListenerHandle.remove();
    }
  }
  async mounted() {
    if (window.google && window.google.maps) {
      this.map = new window.google.maps.Map(this.googleMap, this.options.mapOptions);
      this.googleApi = window.google;
      this.addLocationControl();
      this.AddSelectedListner();
    } else {
      this.loader = new Loader(this.apiKey, this.options.loaderOptions);
      const googleMapLoader = await this.loader.load();
      this.googleApi = googleMapLoader;
      this.initializeMap();
    }
  }
}
